import { DataGrid, GridColDef } from '@mui/x-data-grid';
import pallet from '../../../layouts/pallet';
import { dataGridSx } from '../../common/styled/DataGrid';
import tableColumnUtils from '../../../utils/tableColumnUtils';
import { PageWrapper } from '../../common/styled';
import CustomDataGridToolbar from '../../common/components/CustomDataGridToolbar';

interface Props {
  rows: any[];
}

const ConcessionsAndWaiversReportTable: React.FC<Props> = ({ rows }) => {
  const uniqueKeys = tableColumnUtils.extractUniqueKeys(rows);
  const dynamicColumns: GridColDef[] =
    tableColumnUtils.createColumnsFromKeys(uniqueKeys);
  const columnsToDisplay: GridColDef[] =
    tableColumnUtils.getColumnsToDisplay(dynamicColumns);

  return (
    <PageWrapper>
      <DataGrid
        rowHeight={50}
        rows={rows}
        columns={columnsToDisplay}
        getRowId={(row) => row['id']}
        disableRowSelectionOnClick
        pageSizeOptions={tableColumnUtils.PAGE_SIZE_OPTIONS}
        initialState={tableColumnUtils.DATA_GRID_INITIAL_STATE}
        showToolbar
        slots={{ toolbar: CustomDataGridToolbar }}
        slotProps={{
          toolbar: {
            printOptions: { disableToolbarButton: true },
            showQuickFilter: true
          }
        }}
        sx={{
          ...dataGridSx(pallet),
          '& .MuiDataGrid-virtualScroller': {
            overflowY: 'auto'
          }
        }}
      />
    </PageWrapper>
  );
};

export default ConcessionsAndWaiversReportTable;
